import { z } from 'zod'
import { PHONE_PREFIX, normalizePhone } from '@dorixona/utils'

/** Пользователь печатает только 9 цифр — префикс +998 нарисован рядом (R-01). */
export const NATIONAL_PHONE_LENGTH = 9
export const CODE_LENGTH = 4
/** Регистрация закрыта для рождённых позже (R-03). */
export const MAX_BIRTH_DATE = '2010-12-31'

export function nationalDigits(input: string): string {
  return input.replace(/\D+/g, '').slice(0, NATIONAL_PHONE_LENGTH)
}

/** '901234567' → '90 123-45-67'; частичный ввод маскируется по мере набора. */
export function maskNationalPhone(input: string): string {
  const d = nationalDigits(input)
  let out = d.slice(0, 2)
  if (d.length > 2) out += ` ${d.slice(2, 5)}`
  if (d.length > 5) out += `-${d.slice(5, 7)}`
  if (d.length > 7) out += `-${d.slice(7, 9)}`
  return out
}

export function isCompletePhone(input: string): boolean {
  return nationalDigits(input).length === NATIONAL_PHONE_LENGTH
}

/** Бэкенд ждёт 998 + 9 цифр в любой пунктуации. */
export function toApiPhone(national: string): string {
  return PHONE_PREFIX + nationalDigits(national)
}

/** Показываем полный номер: '901234567' → '+998 90 123-45-67'. */
export function displayPhone(national: string): string {
  return `+${PHONE_PREFIX} ${maskNationalPhone(national)}`
}

/** Вставка кода из СМС целиком тоже проходит здесь. */
export function codeDigits(input: string): string {
  return normalizePhone(input).slice(0, CODE_LENGTH)
}

export function isCompleteCode(input: string): boolean {
  return codeDigits(input).length === CODE_LENGTH
}

export const GENDERS = ['male', 'female'] as const
export type Gender = (typeof GENDERS)[number]

/**
 * Имя и пол обязательны; фамилия и дата рождения — нет.
 * В сообщениях лежат ключи перевода: текст выбирает экран, а не схема.
 */
export const registrationSchema = z.object({
  firstName: z.string().trim().min(1, 'validation.firstName'),
  lastName: z.string().trim(),
  gender: z.enum(GENDERS, { message: 'validation.gender' }),
  birthDate: z
    .string()
    .refine((value) => value === '' || /^\d{4}-\d{2}-\d{2}$/.test(value), 'validation.birthDate')
    .refine((value) => value === '' || value <= MAX_BIRTH_DATE, 'validation.birthDate'),
})

export type RegistrationForm = z.infer<typeof registrationSchema>
